import { useContext } from 'react';
import { Button, Stack, Text } from '@chakra-ui/react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import {
  useEquifaxInDepthTradingHistoryForm,
  useRunEquifaxInDepthTradingHistoryRequest,
} from '~/core/shared/api/plugin';
import { Dialog } from '~/core/shared/components';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../../Layout.component';

export const InDepthTradingHistoryModal = () => {
  const { applicationUuid, setLastApplicationUpdate, actionContexts } =
    useContext(ApplicationContext);

  const {
    action: { key },
  } = useContext(DocumentDetailsViewActionContext);

  const equifaxModalApi: UseOpenCloseReturn = actionContexts[key].modal;

  const { formData } = useEquifaxInDepthTradingHistoryForm(applicationUuid);
  const { runEquifaxInDepthTradingHistoryRequest, isPending } =
    useRunEquifaxInDepthTradingHistoryRequest();

  const startRequest = useEventHandler(
    async (businessUuid: string): Promise<void> => {
      try {
        await runEquifaxInDepthTradingHistoryRequest({
          params: {
            uuid: applicationUuid,
            businessUuid,
          },
        });
        setLastApplicationUpdate(new Date());
        equifaxModalApi.onClose();
      } catch {
        // Error is handled in useRunEquifaxInDepthTradingHistoryRequest
      }
    },
  );

  return (
    <Dialog
      header="Equifax - In-depth Trading History"
      onOpenChange={equifaxModalApi.onOpenChange}
      open={equifaxModalApi.open}
      size="lg"
    >
      <Stack gap={4}>
        {formData && formData.businessName && (
          <Text>
            Run the report on{' '}
            <Text as="span" textStyle="bold">
              {formData.businessName}
            </Text>
            ?
          </Text>
        )}
        {formData && !formData.businessUuid && (
          <Text>
            This loan does not have a corporate entity to run this report.
          </Text>
        )}

        <Stack direction="row" justifyContent="end">
          <Button
            colorPalette="gray"
            fontSize="md"
            fontWeight="normal"
            onClick={equifaxModalApi.onClose}
            variant="outline"
          >
            Cancel
          </Button>
          {formData && formData.businessUuid && (
            <Button
              colorPalette="primary"
              fontSize="md"
              fontWeight="bold"
              loading={isPending}
              onClick={() => startRequest(formData.businessUuid as string)}
              variant="solid"
            >
              Run
            </Button>
          )}
        </Stack>
      </Stack>
    </Dialog>
  );
};
